export const ORDER_ID = ':orderId';
export const BRAND_ID = ':brandId';

export const ROOT = '/';
export const MEDIA = '/media';
export const STORE_LIST = '/store-list';
export const STORE_LOCATION = '/store-location';
export const HOME = '/home';
export const SCAN = '/scan';
export const INVITATION = '/invitation';
export const PRODUCT = '/product/:id';
export const EDENRED = '/edenred';
export const EDENRED_CONFIG = 'config/edenred';
export const CHECK = `/check/${ORDER_ID}`;
export const ORDER_SUCCESS = `/ordersuccess/${ORDER_ID}`;
export const SCAN_CHECK = '/ScanCheck'; // reco -> /scan-check
export const RECEIPT = `/receipt/${ORDER_ID}`;
export const CART = '/cart';
export const POPUP_PAYMENT = '/popupPayment'; // reco -> /popup-payment
export const REWARD = '/reward';
export const PROMO = '/promo';
export const FIDCOUPON = '/fidcoupon';
export const CONVERSION = `${PROMO}/conversion`;

// ACCOUNT
export const ACCOUNT = '/account';
export const LOGIN = '/login';
export const REGISTER = '/register';
export const RESETPASSWORD = '/reset-password';
export const TICKETS = `${ACCOUNT}/tickets`;
export const RECOMPENSES = `${ACCOUNT}/recompenses`;
export const SET_ACCOUNT = `${ACCOUNT}/setAccount`;
export const CONFIG = '/config';
export const UPDATE_USER = `${ACCOUNT}/updateUser`;

//FID
export const USER_FID_CARD = '/user/fid/card';
export const USER_FID_CARD_DETAIL = `${USER_FID_CARD}/detail`;
export const ADD_FID_CARD = `${ACCOUNT}/add/fid/card`;
export const ADD_FID_SCAN = `${ACCOUNT}/add/fid/scan`;
export const NUMBER_SCREEN = `${ACCOUNT}/number`;

// JACKPOT
export const PIKKO_JACKPOT = `/jackpot/${ORDER_ID}`;
export const AMOUNT_CHANGE_JACKPOT = '/amount-change-jackpot';

//MEDIA
export const POLICY = `${MEDIA}/policy`;

//PHONE LOGIN
export const PHONE_PASSWORD_LOGIN = '/phone-password';
export const PHONE_PASSWORD_CREATE = `${PHONE_PASSWORD_LOGIN}/create`;
export const PHONE_PASSWORD_CREATE_CONFIRM = `${PHONE_PASSWORD_LOGIN}/confirm`;
export const PHONE_PASSWORD_FORGOT = `${PHONE_PASSWORD_LOGIN}/forgot`;
export const PHONE_NUMBER_VERIFY = `${PHONE_PASSWORD_LOGIN}/verify`;

// JACKPOT
export const CREATE_FID_CARD_CASHBACK = '/create-fid-card-cashback';
export const MATCH_FIDELITY_FORM = '/match-fidelity-form';
export const FIDELITY_FORM = '/fidelity-form/:companyId';

// DEEPLINK
export const DEEPLINK_5E = '/5e';
